import React, { FunctionComponent, CSSProperties, ChangeEvent } from 'react';
import { MessageTemplate } from '../../../types/messageTemplate';
import { Button } from '../../atoms/button';

type Props = {
  templates: MessageTemplate[];
  targetSpan: string;
  hoverStyle: CSSProperties;
  dustboxStyle: CSSProperties;
  onClicked: () => void;
  handleFetchedTemplate: (event: React.MouseEvent<HTMLSpanElement>) => void;
  handleDeletedTemplate: (event: React.MouseEvent<HTMLElement>) => void;
  filterText: string;
  onFilterChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  templates,
  targetSpan,
  hoverStyle,
  dustboxStyle,
  onClicked,
  handleFetchedTemplate,
  handleDeletedTemplate,
  filterText,
  onFilterChange,
}) => {
  return (
    <div className="message-template-inner-left">
      <Button
        className="message-template-inner-left-new"
        onClicked={onClicked}
        defaultValue="新規作成"
      />
      <input
        type="text"
        inputMode="search"
        placeholder="タイトルで絞り込む"
        className="message-template-inner-left-filter"
        value={filterText}
        onChange={onFilterChange}
      />
      <ul className="message-template-inner-left-box-list">
        {templates.length === 0 ? (
          <li className="message-template-inner-left-box-list-li message-template-inner-left-box-list-li--empty empty">
            <h2 className="empty__title">保存したテンプレートは<br/>ありません</h2>
            <div className="empty__contents">
              <p>求職者とのメッセージのやりとりやスカウトを打つ際に、効率的な運用の手助けになります。</p>
              <p>タイトル、内容を入力して保存したあと、ここに一覧でテンプレートが表示されます。</p>
            </div>
          </li>
        ) : (
          templates.map((template) => (
            <li
              key={`template_${template.id}`}
              className="message-template-inner-left-box-list-li"
            >
              <span
                key={`text_${template.id}`}
                className="message-template-inner-left-box-list-li-text"
                onClick={handleFetchedTemplate}
                data-body={template.body}
                data-id={template.id}
                style={targetSpan === template.title ? hoverStyle : {}}
              >
                {template.title}
              </span>
              <i
                key={`delete_${template.id}`}
                className="fas fa-trash-alt"
                onClick={handleDeletedTemplate}
                data-id={template.id}
                style={targetSpan === template.title ? dustboxStyle : {}}
              ></i>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};
